// extracted by mini-css-extract-plugin
export default {"framework-selector":"T_cg d-flex","framework-selector__icon":"T_ch","framework-selector__option":"T_cj p-2 flex-grow-1 ml-2","framework-selector__option--selected":"T_ck"};